import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRoute, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

@Injectable()
export class OldVersionService implements CanActivate {

  constructor(
    private router: Router,
    private route: ActivatedRoute
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    console.log("OldVersionService -> ActivatedRouteSnapshot -> route=", route);

    var year = parseInt(route.params.year);
    console.log(year);
    const isOldVersion = year < 2021;

    return isOldVersion;

  }

}
